import { css } from "lit";

export const accordionStyles = css`
   .accordion-button {
        text-align: left;
        display: flex;
        border: none;
        width: 100%;
        cursor: pointer;
        background: inherit;
    }
    .accordion-button label {
        cursor: pointer;
    }
    .accordion-heading {
        margin: 0;
        border-bottom: 1px solid var(--divider-color-closed);
    }
    .accordion-heading[aria-expanded="true"] {
        border-bottom: 0;
    }
    .accordion-content {
        padding-left: 24px;
        margin-top: 12px;
    }
    `;